import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["width", "height"]
const _hoisted_2 = ["transform", "stroke"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", {
    overflow: "hidden",
    class: "radial-progress-bar",
    width: _ctx.diameter,
    height: _ctx.diameter,
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    _createElementVNode("circle", {
      transform: 'rotate(' + _ctx.rotation + ', ' + _ctx.radius + ',' + _ctx.radius + ')',
      r: "120.57692307692308",
      cx: "145.2",
      cy: "145.2",
      fill: "transparent",
      stroke: _ctx.strokeColor,
      "stroke-dasharray": "750",
      "stroke-dashoffset": "0",
      "stroke-linecap": "round",
      style: _normalizeStyle(_ctx.innerStrokeStyle as any)
    }, null, 12, _hoisted_2)
  ], 8, _hoisted_1))
}